import { Injectable } from "@angular/core";
import { StoreService } from "../store.service";
import { USER_STORE_DATA_ENUM } from "./user-types";

export interface LoanProperties {
    loanId: string;
    applicationId: string;
    loanCategory: string;
    amount: number;
    discount: number;
    coupon: string;
    couponName: string;
    interestRate: number;
    tenure: number;
    processingFee: number;
    netDisbursement: number;
    loanSactionedAmount: number;
    loanEligibleAmount: number;
    dueAmount?: number;
    emiNumber?: string;
    repaymentStatus?: string;
    repaymentType?: string;
    lateFee?: number;
    transactionId?: string;
    transactionDate?: string;
    repaymentMethod?: string;
    writeOffAmount?: number;
}

@Injectable({
    providedIn: "root",
})
export class LoanPropertiesService {
    private loanProperties: Partial<LoanProperties> = {};
    private isInitialized = false;

    constructor(private store: StoreService) {}

    clearLoanDetails(): void {
        this.loanProperties = {};
        this.isInitialized = false;
        this.store.remove(USER_STORE_DATA_ENUM.loanDetails);
    }

    private collectLoanPropertiesFromStore(): Partial<LoanProperties> {
        const loadDetails: Partial<LoanProperties> = JSON.parse(
            this.store.get(USER_STORE_DATA_ENUM.loanDetails) || "{}"
        );

        this.loanProperties = {
            loanId: loadDetails.loanId,
            applicationId: this.store.get("applicationId") || "",
            loanCategory: loadDetails.loanCategory,
            amount: loadDetails.amount,
            discount: loadDetails.discount,
            coupon: loadDetails.coupon,
            couponName: loadDetails.couponName,
            interestRate: Number(loadDetails.interestRate),
            tenure: loadDetails.tenure,
            processingFee: loadDetails.processingFee,
            netDisbursement: loadDetails.netDisbursement,
            loanSactionedAmount: loadDetails.loanSactionedAmount,
            loanEligibleAmount: loadDetails.loanEligibleAmount,
            dueAmount: loadDetails.dueAmount,
            emiNumber: loadDetails.emiNumber,
            repaymentStatus: loadDetails.repaymentStatus,
            repaymentType: loadDetails.repaymentType,
            lateFee: loadDetails.lateFee,
            transactionId: loadDetails.transactionId,
            transactionDate: loadDetails.transactionDate,
            repaymentMethod: loadDetails.repaymentMethod,
            writeOffAmount: loadDetails.writeOffAmount,
        };

        this.isInitialized = true;
        return this.loanProperties;
    }

    getLoanProperties(): Partial<LoanProperties> {
        return this.collectLoanPropertiesFromStore();
    }

    updateLoanProperties(data: Partial<{ [key in keyof LoanProperties]: any }>): void {
        const updatedLoanDetails = {
            ...this.loanProperties,
            ...data,
        };

        this.store.set({
            key: USER_STORE_DATA_ENUM.loanDetails,
            value: JSON.stringify(updatedLoanDetails),
        });
        this.loanProperties = updatedLoanDetails;
    }
}
